import { gsap } from 'gsap';

export function logoInit(el) {
  const bg = el.querySelector('.app-logo__bg');
  const flowerTop = el.querySelector('.app-logo__flower--top');
  const flowerLeft = el.querySelector('.app-logo__flower--left');
  const flowerRight = el.querySelector('.app-logo__flower--right');
  const text = el.querySelector('.app-logo__gucci');

  gsap.set(bg, { y: 35, opacity: 0 });
  gsap.set(flowerTop, { scale: 0, transformOrigin: '50% 100%' });
  gsap.set(flowerLeft, { scale: 0, transformOrigin: '60% 100%' });
  gsap.set(flowerRight, { scale: 0, transformOrigin: '40% 100%' });
  gsap.set(text, {
    y: 15,
    scale: 1.1,
    opacity: 0,
    transformOrigin: '50% 0%',
  });
}

export function logoEnter(el, delay = 0) {
  const bg = el.querySelector('.app-logo__bg');
  const flowerTop = el.querySelector('.app-logo__flower--top');
  const flowerLeft = el.querySelector('.app-logo__flower--left');
  const flowerRight = el.querySelector('.app-logo__flower--right');
  const text = el.querySelector('.app-logo__gucci');
  const tl = gsap.timeline({ delay });

  tl.addLabel('start')
    .to(bg, {
      y: 0,
      opacity: 1,
      ease: 'bloom',
      duration: 1.5,
    }, 'start')
    .to(flowerTop, {
      scale: 1,
      ease: 'bloom',
      duration: 1.5,
    }, 'start+=0.5')
    .to([flowerLeft, flowerRight], {
      scale: 1,
      ease: 'bloom',
      duration: 1.25,
    }, 'start+=1')
    .to(text, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 1.25,
      ease: 'bloom',
    }, 'start+=0.8');

  return tl;
}

export function logoLeave(el) {
  el.removeAttribute('data-animated');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, {
      scale: 0.8,
      opacity: 0,
      ease: 'bloom',
    }, 'start');

  return tl;
}
